export const agreementsGet = "/sys/agreements";//获取列表
export const agreementsSeach = (orderItemId) => {return "/sys/agreements/" + orderItemId + "/by-orderItem"};//查看详情
